import React from 'react';

const icon = ({ className = '', ...props }) => (
  <span className={`svg-icon ${className}`} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" stroke="currentColor">
        <path strokeLinecap="round" strokeMiterlimit="10" d="M22.927 9.581l-5.854-5.854M17.073 9.581l5.854-5.854M20 11.655L9.062 29.165M20 11.655l10.938 17.51" />
        <path strokeLinejoin="round" d="M26.556 22.442l-6.573 4.683-6.539-4.65" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 36.273V12.207" />
      </g>
    </svg>
  </span>
);

export default icon;
